module.exports = __webpack_public_path__ + "static/media/vanillaFrosting.dfe9dce7.webp";